/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ArtistService from '../../../services/artistService';
import LocationService from '../../../services/locationService';
import {distances, distanceUnits, expertises} from '../../../constants/staticLists';
import AsyncTypeahead from 'react-bootstrap-typeahead/lib/AsyncTypeahead.react'; 
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as browserCheck from '../../../utils/browserCheck.js';
import { addTask } from 'domain-task';
import ErrorMessage from '../../common/ErrorMessage.js';
import MaterialDropDown from '../../common/MaterialDropDown';
import * as qs from 'query-string';

class Browse extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.filter = this.filter.bind(this);
        this.onChange = this.onChange.bind(this);
        this.formIsValid = this.formIsValid.bind(this);
        this.loadSortOptions = this.loadSortOptions.bind(this);
        this.loadCapacities = this.loadCapacities.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.updateGenre = this.updateGenre.bind(this);        
        this.showInfluences = this.showInfluences.bind(this);
        this.filterClick = this.filterClick.bind(this);
        this.updateDistance = this.updateDistance.bind(this);
        this.updateDistanceUnit = this.updateDistanceUnit.bind(this);
        this.updateInstrument = this.updateInstrument.bind(this);
        this.updateExpertise = this.updateExpertise.bind(this);
        this.getGenreText = this.getGenreText.bind(this);
        this.locationSearch = this.locationSearch.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.influencesSearch = this.influencesSearch.bind(this);
        this.influencesSelected = this.influencesSelected.bind(this); 
        this.addDefaultGenre = this.addDefaultGenre.bind(this); 
        this.sortOptions = {};        
        this.capacities = [];
        const params = qs.parse(this.props.location.search);
        //we should initialise the location from the user's role if set
        this.state = {
            locationTypeaheadLoading: false,
            locationTypeaheadOptions: [],
            locationFocused: false,
            influencesTypeaheadLoading: false,
            influencesTpeaheadOptions: [],
            initialPage: params && params.page || 1
        };
    }

    componentWillMount() {        
        this.loadSortOptions();
        this.loadCapacities();
        this.props.actions.getInstruments();
        this.props.actions.updateSort('Default');
        this.props.actions.updateDistanceUnit(distanceUnits[0]);   
        const getGenresPromise = this.props.actions.getGenres();
        //we want to wait for the genres or association before we kick off the action to load the results
        //this is because we might want to load the page with a default genre or association
        //we should only wait if we have a genre or association parameter
        const waitForPromises = [];
        let mustWait = false;
        if(this.props.genreParam && this.props.genreParam != 'like') {
            mustWait = true;
            waitForPromises.push(getGenresPromise
                .then(genres => {
                    //clear associations, we can't default both the genre and associations
                    this.props.actions.setBrowseAssociations([]);
                    this.addDefaultGenre(genres);                    
                    return genres;
                }));
        }
        if(this.props.associationParam) {
            mustWait = true;
            waitForPromises.push(ArtistService.getAssociations(this.props.associationParam, this.props.roleType.type)
                .then(items => {
                    //clear genres, we can't default both the genre and associations
                    this.props.actions.clearBrowseGenres();
                    const associations = items.slice(0, 1);
                    this.props.actions.setBrowseAssociations(associations);
                    return associations;
                }));
        }
        if(!mustWait) {
            this.props.actions.browseProfiles(this.state.initialPage);
        }
        else {
            addTask(Promise.all(waitForPromises).then(values => {
                return this.props.actions.browseProfiles(this.state.initialPage);
              }));
        }
        if(!this.props.searchCriteria.location || !this.props.searchCriteria.location.length && this.props.user) {
            //default to the user's location
            const user = this.props.user;
            const label = user ? `${user.City}, ${user.Region}` : '';
            const items = [{
                  label: label,
                  value: label,
                  city: user ? user.City : '',
                  region: user ? user.Region : '',
                  country: user ? user.Country : '',
                  longitude: user ? user.Longitude : '',
                  latitude: user ? user.Latitude : ''
            }];
            this.props.actions.updateLocation(items);
        }
    }   

    componentDidMount() {
        if(browserCheck.canUseDom()) {                
            window.componentHandler.upgradeDom();      
            const {getmdlSelect} = require('../../../scripts/getmdl-select.js');
            getmdlSelect.init('#divFilterResultsDrop .getmdl-select');    
            $('#DistanceUnit').parent().addClass('is-dirty');    
            $('#Sort').parent().addClass('is-dirty');   
        }
    }    

    addDefaultGenre(genres) {
        const genre = this.props.genreParam;
        if(genre) {
            const matchingGenre = genres.find(g => g.toLowerCase() == genre.toLowerCase());
            if(matchingGenre && !this.props.searchCriteria.selectedGenres.find(g => g.toLowerCase() == genre.toLowerCase())) {
                this.props.actions.clearBrowseGenres();
                this.props.actions.addBrowseGenre(matchingGenre);
            }
        }
    }

    filterClick(event) {
        event.preventDefault();
        $(event.target).toggleClass('open');
        $('#divFilterResultsDrop').slideToggle();
    }

    loadSortOptions() {
        this.sortOptions['Default'] = 'Default';
        this.sortOptions['JoinDate'] = 'Join date';
        this.sortOptions['Name'] = 'Name';
        if(ArtistService.showRating(this.props.roleType.type)) {
            this.sortOptions['Rating'] = 'Rating';
        }
        this.sortOptions['City'] = 'City';   
        if(ArtistService.showCapacity(this.props.roleType.type)) {
            this.sortOptions['Capacity'] = 'Capacity';
        }
        if(ArtistService.showInstrument(this.props.roleType.type)) {
            this.sortOptions['Instrument'] = 'Instrument';
        }  
        this.sortOptions['PluggedIn'] = 'Plugged in';
    }

    loadCapacities() {
        this.capacities.push({min: 0, max: 100, display: '0-100'});
        this.capacities.push({min: 100, max: 300, display: '100-300'});
        this.capacities.push({min: 300, max: 1000, display: '300-1000'});
        this.capacities.push({min: 1000, max: null, display: '1000+'});
    }

    updateSort(event, refreshData = false) {
        const value = event.target.dataset.val;
        this.props.actions.updateSort(value);
        if(refreshData) {
            this.filter(event);
        }
    }
    
    updateCapacity(event) {
        const value = event.target.dataset.val;
        this.props.actions.updateCapacity(this.capacities.find(c => c.display == value));
    }

    updateGenre(event) {
        //clicking seems to hide the drop down so let's add it back
        $('.multidropdown').addClass('open');
        const value = event.target.value;
        const checked = event.target.checked;
        if(checked) {
            this.props.actions.addBrowseGenre(value);
        }
        else {
            this.props.actions.removeBrowseGenre(value);
        }
    }

    updateDistance(event) {
        const value = event.target.innerText;
        this.props.actions.updateDistance(value);
    }

    updateDistanceUnit(event) {
        const value = event.target.innerText;
        this.props.actions.updateDistanceUnit(value);
    }

    updateInstrument(event) {
        const value = event.target.innerText;
        this.props.actions.updateInstrument(value);
    }

    updateExpertise(event) {
        const value = event.target.innerText;
        this.props.actions.updateExpertise(value);
    }

    locationSearch(query) {
        this.setState({locationTypeaheadLoading: true});
        LocationService.searchLocation('', false, true, query)
        .then(items => {
            this.setState({
                locationTypeaheadLoading: false,
                locationTypeaheadOptions: items
            });
        } );
    }

    locationSelected(items) {
        this.props.actions.updateLocation(items);        
    }
    
    influencesSearch(query) {
        this.setState({influencesTypeaheadLoading: true});
        ArtistService.getAssociations(query, this.props.roleType.type)
        .then(items => {
            this.setState({
                influencesTypeaheadLoading: false,
                influencesTypeaheadOptions: items
            });
        });
    }

    influencesSelected(items) {
        this.props.actions.setBrowseAssociations(items);
    }

    showInfluences() {
        return ArtistService.showInfluences(this.props.roleType.type);
    }

    getGenreText() {
        if(this.props.searchCriteria.selectedGenres.length == 0) {
            return 'Select Genres';
        }
        else {
            const genreText = this.props.searchCriteria.selectedGenres.toString().replace(/,/g, ', ');
            return genreText;
        }
    }

    filter(event) {
        event.preventDefault();
        if(this.formIsValid()) {
            this.props.actions.browseProfiles();
        }
    }

    onChange(event) {
        const field = event.target.name;
        const value = event.target.value;
        let newState = Object.assign({}, this.state);
		newState[field] = value;
		return this.setState(newState);
    }

    formIsValid() {
        return true;
    }

    render() {
        const buttonMarginTop = this.props.roleType.type == 'RecordingStudio' || this.props.roleType.type == 'Venue' || this.props.roleType.type == 'RecordLabel' || this.props.roleType.type == 'Promoter' || this.props.roleType.type == 'Manager' ? '5px' : '50px';
        return (
            <React.Fragment>
                <div className="sfilt">
                    <form id="frmSort" name="form-sort" method="post" action="" className="form form-inline form-sort">
                        <div className="sortbox pull-right">
                            <label htmlFor="sortsel">Sort by:&nbsp;</label>
                            <MaterialDropDown 
                                name="Sort"
                                label=" "
                                data-val={this.props.searchCriteria.sort}
                                data={Object.keys(this.sortOptions)}
                                value={this.sortOptions[this.props.searchCriteria.sort]}
                                onClick={(e) => this.updateSort(e, true)}
                                itemTextFunc={(key) => this.sortOptions[key]} />
                        </div>
                    </form>
                    <a id="aFilterResultsDrop" href="#" className="btn-sfilters btn-simple transition" style={{borderColor:'#ddd', marginTop:'20px', display:'inline-block'}} onClick={this.filterClick}>
                        Filter results&nbsp;
                        <span className="caret-dn">
                            <span className="arrow-down" />
                        </span>
                        <span className="caret-up">
                            <span className="arrow-up" />
                        </span>
                    </a>
                </div>
                <div style={{clear:'both'}} />
                <div id="divFilterResultsDrop" className="searchfilters">
                    <form id="frmSearchFilter" name="form-sfilter" method="post" action="" className="form form-regular form-block">
                        <ErrorMessage error={this.props.browseError} onClose={this.props.actions.clearBrowseError} />
                        <div className="row">
                            {ArtistService.showGenre(this.props.roleType.type) ?
                                <div className="col-md-4">
                                    <div id="divBrowseGenres" className="genre">
                                        <p className="formlegend">BY GENRE</p>
                                        <div className="dropdown multidropdown">
                                            <a href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                                <span className="selection">{this.getGenreText()}</span>
                                                <span className="caret" />
                                            </a>
                                            <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                                                <ul className="list-unstyled">
                                                    {
                                                        this.props.genres.map((genre, i) => 
                                                        {
                                                            const checked = this.props.searchCriteria.selectedGenres.includes(genre);
                                                            return <li key={genre}>
                                                                <label className="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" htmlFor={`checkbox-${i}`}>
                                                                    {checked ?
                                                                        <input type="checkbox" id={`checkbox-${i}`} className="mdl-checkbox__input" name="SelectedGenres" value={genre} onChange={this.updateGenre} checked />
                                                                        : <input type="checkbox" id={`checkbox-${i}`} className="mdl-checkbox__input" name="SelectedGenres" value={genre} onChange={this.updateGenre} />}
                                                                    <span className="mdl-checkbox__label">{genre}</span>
                                                                </label>
                                                            </li>;
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null
                            }
                            {
                                ArtistService.showCapacity(this.props.roleType.type) ?
                                <div className="col-md-4">
                                    <p className="formlegend">BY CAPACITY</p>
                                    <MaterialDropDown
                                        name="SelectedCapacity"
                                        className="placeholder getmdl-select__fullwidth"
                                        label="Capacity"
                                        value={this.props.searchCriteria.selectedCapacity ? this.props.searchCriteria.selectedCapacity.display: ''}
                                        data={this.capacities}
                                        onClick={this.updateCapacity}
                                        itemValueFunc={(capacity) => capacity.min}
                                        itemTextFunc={(capacity) => capacity.display} />
                                </div>       
                                : null
                            }
                            <div className="col-md-8">
                                <div className="row row-breakatsmall">
                                    <div className="col-xs-6">
                                        <p className="formlegend">WITHIN</p>
                                        <div className="form-within">
                                            <MaterialDropDown 
                                                name="Distance" 
                                                className="placeholder select-distance"
                                                data={distances}
                                                onClick={this.updateDistance}
                                                value={this.props.searchCriteria.distance} />
                                            <MaterialDropDown
                                                name="DistanceUnit"
                                                className="select-unit"
                                                value={this.props.searchCriteria.distanceUnit}
                                                data={distanceUnits}
                                                showLabel={false}
                                                onClick={this.updateDistanceUnit} />
                                        </div>
                                    </div>
                                    <div id="divLocation" className="col-xs-6">
                                        <p className="formlegend">OF</p>
                                        <div className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block ${this.state.locationFocused ? 'is-focused' : ''} ${this.props.searchCriteria.location && this.props.searchCriteria.location.length ? 'is-dirty' : ''}`}>
                                            <AsyncTypeahead id="Location"  minLength={3} isLoading={this.state.locationTypeaheadLoading} onSearch={this.locationSearch} onChange={this.locationSelected} options={this.state.locationTypeaheadOptions} selected={this.props.searchCriteria.location} onFocus={() => this.setState({locationFocused: true})} onBlur={() => this.setState({locationFocused: false})} />
                                            {/*<input className="mdl-textfield__input typeahead" type="text" id="Location" name="Location" value={this.props.searchCriteria.location} autoComplete="off" />*/}
                                            <label className="mdl-textfield__label" htmlFor="Location">City Name</label>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {
                                ArtistService.showInstrument(this.props.roleType.type) ?
                                <div className="col-md-4">
                                    <p className="formlegend">BY INSTRUMENT</p>
                                    <div className="form-within">
                                        <MaterialDropDown
                                            name="Instrument"
                                            className="placeholder getmdl-select--limited"
                                            data={this.props.instruments}
                                            onClick={this.updateInstrument} />
                                        <MaterialDropDown
                                            name="Expertise"
                                            className="placeholder"
                                            data={expertises}
                                            onClick={this.updateExpertise} />
                                    </div>
                                </div>
                                : null
                            }                            
                            {
                                this.showInfluences() ?
                                <div id="divBrowseInfluences" className="col-md-4 col-sm-6">
                                    <p className="formlegend">
                                        {this.props.roleType.type == 'Fan' ? 'BY FAVOURITE ARTISTS' : 'BY INFLUENCES'}
                                    </p>
                                    <div className="form-group form-multiselect">
                                        <div className="materialize-autocomplete" style={{paddingBottom:'0'}}>
                                            {/*<label htmlFor="tags">{this.props.roleType.type == 'Producer' ? 'Producer Name' : 'Artist Name'}</label>*/}
                                            <AsyncTypeahead id="txtInfluences" multiple placeholder={this.props.roleType.type == 'Producer' ? 'Producer Name' : 'Artist Name'} minLength={3} isLoading={this.state.influencesTypeaheadLoading} onSearch={this.influencesSearch} onChange={this.influencesSelected} options={this.state.influencesTypeaheadOptions} selected={this.props.searchCriteria.selectedAssociations} />
                                        
                                            {/*<input type="text" name="AssociationIDs" id="txtInfluences" className="input-influences" />*/}
                                        </div>
                                        <p className="help-block">{`e.g. ${this.props.roleType.type == 'Producer' ? 'Timbaland, Dr Dre' : 'The Beatles, Kanye West'}, etc`}</p>
                                    </div>
                                </div>
                                : null
                            }
                            {
                                this.props.roleType.type != 'Musician' ? <br /> : null
                                
                            }
                            <div className="col-md-4 col-sm-12">
                                <button className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent btn-filter" style={{marginTop: buttonMarginTop}} onClick={this.filter}>FILTER</button>
                            </div>
                        </div>
                    </form>
                </div>
            </React.Fragment>
        );
    }
}

Browse.propTypes = {
    searchCriteria: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    roleType: PropTypes.object.isRequired,
    browseError: PropTypes.string,
    genres: PropTypes.array.isRequired,
    genreParam: PropTypes.string,
    associationParam: PropTypes.string,
    instruments: PropTypes.array.isRequired,
    getGenresPromise: PropTypes.object,
    user: PropTypes.object,
    location: PropTypes.object.isRequired
};

export default Browse;


